// extracted by mini-css-extract-plugin
export default {"entryPage":"entryPage_entryPage__x3D8n","form":"entryPage_form__tsz0n","input":"entryPage_input__hgrLb","button":"entryPage_button__EmyNk","error":"entryPage_error__6kEiY"};